import { Building2, User, X, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { RELATIONSHIPS, relationshipCls, summarize } from "./intakeModel";

const RelToggle = ({ value, onChange, id }) => (
  <div className="flex rounded-full border border-white/10 overflow-hidden" data-testid={`intake-rel-${id}`}>
    {RELATIONSHIPS.map((r) => (
      <button key={r.id} onClick={() => onChange(r.id)} data-testid={`intake-rel-${id}-${r.id}`}
        className={`text-[11px] px-2.5 py-1 transition-colors ${value === r.id ? relationshipCls(r.id) : "text-gray-500 hover:text-gray-300"}`}>
        {r.short}
      </button>
    ))}
  </div>
);

const ItemRow = ({ item, onRel, onRemove }) => {
  const Icon = item.kind === "contact" ? User : Building2;
  return (
    <li className="flex items-center gap-3 py-2.5 border-b border-white/5 last:border-0" data-testid={`intake-item-${item.id}`}>
      <Icon className={`h-4 w-4 flex-shrink-0 ${item.kind === "contact" ? "text-amber-300/80" : "text-ism-teal"}`} />
      <div className="min-w-0 flex-1">
        <p className="text-sm text-white truncate">
          {item.kind === "contact" ? item.contactName : item.companyName}
          {item.kind === "contact" && item.companyName && <span className="text-gray-500"> · {item.companyName}</span>}
        </p>
        <p className="text-[11px] text-gray-500 truncate">
          {[item.contactTitle, item.contactEmail, item.website, item.industry, item.notes].filter(Boolean).join(" · ") || item.source}
          {item.existingAccountId && <span className="ml-2 text-amber-300/80">already in your accounts</span>}
        </p>
      </div>
      <RelToggle id={item.id} value={item.relationship} onChange={onRel} />
      <button onClick={onRemove} className="text-gray-600 hover:text-red-400 flex-shrink-0" aria-label="Remove" data-testid={`intake-remove-${item.id}`}><X className="h-4 w-4" /></button>
    </li>
  );
};

export const IntakeReview = ({ items, setRelationship, setAllRelationship, removeItem, clear }) => {
  if (!items.length) return null;
  const s = summarize(items);
  return (
    <div className="rounded-xl border border-white/10 bg-white/[0.02]" data-testid="intake-review">
      <div className="flex items-center justify-between gap-3 flex-wrap px-4 py-3 border-b border-white/10">
        <p className="text-xs text-gray-400" data-testid="intake-review-summary">
          <span className="text-white">{s.accounts}</span> companies · <span className="text-white">{s.contacts}</span> people ·{" "}
          <span className="text-emerald-300">{s.customer}</span> customers · <span className="text-ism-teal">{s.wishlist}</span> wishlist
          {s.existing > 0 && <> · <span className="text-amber-300/80">{s.existing} already known</span></>}
        </p>
        <div className="flex items-center gap-2">
          <span className="text-[11px] text-gray-500">Mark all:</span>
          {RELATIONSHIPS.map((r) => (
            <button key={r.id} onClick={() => setAllRelationship(r.id)} className={`text-[11px] px-2 py-0.5 rounded-full border ${relationshipCls(r.id)}`} data-testid={`intake-all-${r.id}`}>{r.short}</button>
          ))}
          <Button variant="ghost" size="sm" onClick={clear} className="text-gray-500 hover:text-red-400 h-7 px-2" data-testid="intake-clear-btn"><Trash2 className="h-3.5 w-3.5" /></Button>
        </div>
      </div>
      <ul className="px-4 max-h-72 overflow-y-auto" data-testid="intake-review-list">
        {items.map((it) => <ItemRow key={it.id} item={it} onRel={(rel) => setRelationship(it.id, rel)} onRemove={() => removeItem(it.id)} />)}
      </ul>
    </div>
  );
};
